import { Injectable } from '@angular/core';
import {
    GenericHealthService,
    SingletonServiceGuard
} from '@lsq-frontend/angular-shared/features/generic-get-services';

@Injectable({ providedIn: 'root' })
export class RefreshTokensService {
    constructor(private _healthService: GenericHealthService) {
        SingletonServiceGuard.register('RefreshTokensService');
    }

    public async execute(): Promise<void> {
        await this._healthService.executeOnce();
    }
}
